import { Tooltip as MantineTooltip } from '@mantine/core';
import classes from './tooltip.module.scss';

export const Tooltip = MantineTooltip.extend({
  classNames: classes,
});
